/**
 * Возвращает период по сегодняшнему дню
 * @returns {{from: Date, to: Date}}
 */
function getPeriodToday () {
  const now = new Date()
  return {
    from: now,
    to: now
  }
}

/**
 * Возвращает период со вчерашнего дня по сегодняшний
 * @returns {{from: Date, to: Date}}
 */
function getPeriodYesterday () {
  const now = new Date()
  return {
    from: new Date(now.setDate(now.getDate() - 1)),
    to: now
  }
}

/**
 * Возвращает период текущей недели
 * @returns {{from: Date, to: Date}}
 */
function getPeriodThisWeek () {
  const now = new Date()
  const day = now.getDay()
  const diff = now.getDate() - day + (day === 0 ? -6 : 1)
  return {
    from: new Date(now.setDate(diff)),
    to: now
  }
}

/**
 * Возвращает период предыдущей недели
 * @returns {{from: Date, to: Date}}
 */
function getPeriodPreviousWeek () {
  const now = new Date()
  const day = now.getDay()
  const diffFrom = now.getDate() - day + (day === 0 ? -13 : -6)
  const diffTo = now.getDate() - day + (day === 0 ? -6 : 0)
  return {
    from: new Date(now.setDate(diffFrom)),
    to: new Date(now.setDate(diffTo))
  }
}

/**
 * Возвращает период последних 7 дней
 * @returns {{from: Date, to: Date}}
 */
function getPeriodLast7Days () {
  const now = new Date()
  const tsLast7Days = (new Date()).setDate(now.getDate() - 7)
  return {
    from: new Date(tsLast7Days),
    to: now
  }
}

/**
 * Возвращает период текущего месяца
 * @returns {{from: Date, to: Date}}
 */
function getPeriodThisMonth () {
  const now = new Date()
  return {
    from: new Date(now.getFullYear(), now.getMonth(), 1),
    to: now
  }
}

/**
 * Возвращает период предыдущего месяца
 * @returns {{from: Date, to: Date}}
 */
function getPeriodPreviousMonth () {
  const now = new Date()
  return {
    from: new Date(now.getFullYear(), now.getMonth() - 1, 1),
    to: new Date(now.getFullYear(), now.getMonth(), 0)
  }
}

/**
 * Возвращает период последних 30 дней
 * @returns {{from: Date, to: Date}}
 */
function getPeriodLast30Days () {
  const now = new Date()
  const tsLast30Days = (new Date()).setDate(now.getDate() - 30)
  return {
    from: new Date(tsLast30Days),
    to: now
  }
}

/**
 * Возвращает период последних 90 дней
 * @returns {{from: Date, to: Date}}
 */
function getPeriodLast90Days () {
  const now = new Date()
  const tsLast90Days = (new Date()).setDate(now.getDate() - 90)
  return {
    from: new Date(tsLast90Days),
    to: now
  }
}

export default {
  methods: {
    /**
     * Возвращает идентификатор периода по его началу и концу в формате Y-m-d
     * @param from Начало периода
     * @param to Конец периода
     * @returns {string}
     */
    getNameByPeriod (from, to) {
      const periodNames = [
        'today',
        'yesterday',
        'this_week',
        'previous_week',
        'last_7_days',
        'this_month',
        'previous_month',
        'last_30_days',
        'last_90_days'
      ]
      for (let i = 0; i < periodNames.length; i++) {
        const period = this.getPeriodByName(periodNames[i])
        if (period.from.localeCompare(from) === 0 && period.to.localeCompare(to) === 0) {
          return periodNames[i]
        }
      }
      return 'user'
    },
    /**
     * Возвращает объект с периодом по ключу
     * @param periodName Название периода
     * @returns {{from: string, to: string}}
     */
    getPeriodByName (periodName) {
      const periods = {
        today: getPeriodToday(),
        yesterday: getPeriodYesterday(),
        this_week: getPeriodThisWeek(),
        previous_week: getPeriodPreviousWeek(),
        last_7_days: getPeriodLast7Days(),
        this_month: getPeriodThisMonth(),
        previous_month: getPeriodPreviousMonth(),
        last_30_days: getPeriodLast30Days(),
        last_90_days: getPeriodLast90Days(),
        user: {
          from: null,
          to: null
        }
      }
      const result = periods[periodName] !== undefined
        ? periods[periodName]
        : periods.today
      return {
        from: result.from.toLocaleDateString('en-CA'),
        to: result.to.toLocaleDateString('en-CA')
      }
    },
    /**
     * Возвращает название периода по идентификатору
     * @param periodName Идентификатор периода
     * @returns {string}
     */
    getPeriodText (periodName) {
      const periods = {
        today: 'Сегодня',
        yesterday: 'Вчера',
        this_week: 'Эта неделя',
        previous_week: 'Прошлая неделя',
        last_7_days: 'Последние 7 дней',
        this_month: 'Этот месяц',
        previous_month: 'Предыдущий месяц',
        last_30_days: 'Последние 30 дней',
        last_90_days: 'Последние 90 дней',
        user: 'Пользовательский'
      }
      return periods[periodName] !== undefined
        ? periods[periodName]
        : periods.today
    }
  }
}
